import { Dispatch } from 'react-redux';
import { AxiosError } from "axios";
import { AuthActionCreators, IApplicationState } from "../";
import { IVoucherSimulationAnnualResult, IVoucherSimulationConfig, IVoucherSimulationConfigSummary, IVoucherSimulationSummary } from "../../models";
import { IGet, IPost } from '../authorization';


export interface IVoucherSimulationConfigOverride {
    name: string,
    growthVariability: number,
    growthRate: number[],
    eligibilityForTransplant: number[],
    mortalityRisk: number[],
    esrdRisk: number[]
}

export interface IVoucherSimulationConfigDefaultsResponse {
    data: {
        success: boolean,
        message: string,
        results: IVoucherSimulationConfig
    }
}

export interface IVoucherSimulationResponse {
    data: {
        success: boolean,
        message: string,
        results: string
    }
}

export interface IVoucherSimulationSummaryResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            summary: IVoucherSimulationSummary[]
            config: IVoucherSimulationConfigSummary
        }
    }
}

export interface IVoucherSimulationRunResponse {
    data: {
        success: boolean,
        message: string,
        results: IVoucherSimulationAnnualResult[]
    }
}

export const ActionCreators = {
    getConfigDefaults: () => (dispatch: Dispatch<IApplicationState>): Promise<IVoucherSimulationConfigDefaultsResponse> => {
        var options: IGet = {
            url: `${__API__}/voucher/simulation/config-defaults`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IVoucherSimulationConfigDefaultsResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    getSimulationConfigJson: (numberOfRuns: number, override: IVoucherSimulationConfigOverride) => (dispatch: Dispatch<IApplicationState>): Promise<any> => {
        var options: IPost = {
            url: `${__API__}/voucher/simulation/config?format=${2}`,
            data: {
                numberOfRuns,
                override
            }
        };

        return dispatch(AuthActionCreators.apiPost(options))
            .then((response: any) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    submitSimulation: (numberOfRuns: number, override: IVoucherSimulationConfigOverride) => (dispatch: Dispatch<IApplicationState>): Promise<IVoucherSimulationResponse> => {
        var options: IPost = {
            url: `${__API__}/voucher/simulate/with-override`,
            data: {
                numberOfRuns,
                override
            }
        };

        return dispatch(AuthActionCreators.apiPost(options))
            .then((response: IVoucherSimulationResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    getSimulationSummary: (fileId: string, percentile: number) => (dispatch: Dispatch<IApplicationState>): Promise<IVoucherSimulationSummaryResponse> => {
        var options: IGet = {
            url: `${__API__}/voucher/simulation/${fileId}/summary/${percentile}`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IVoucherSimulationSummaryResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    getSimulationRunCsv: (fileId: string, runNumber: number) => (dispatch: Dispatch<IApplicationState>) => {
        var options: IGet = {
            url: `${__API__}/voucher/simulation/${fileId}/run/${runNumber}.csv`,
            responseType: 'blob'
        };

        return dispatch(AuthActionCreators.apiGet(options));
    },
}

export interface IVoucherSimulationState {
}

var initialState: IVoucherSimulationState = {
};

const createReducer = (initialState: IVoucherSimulationState, handlers: any) => {
    return function reducer(state = initialState, action: any) {
        if (handlers.hasOwnProperty(action.type)) {
            let s = Object.assign({}, state);
            return handlers[action.type](s, action);
        } else {
            return state;
        }
    }
}

const handlers = {
};

export const Reducer = createReducer(initialState, handlers);
